import moment from 'moment'

export default {
    params: [
        'dataInicial',
        'horaInicial',
        'dataFinal',
        'horaFinal',
        'isInicial'
    ],
    validate: (_, { dataInicial, horaInicial, dataFinal, horaFinal, isInicial }) => {

        const dateFormatUs = 'YYYY-MM-DD'
        const dateTimeFormatUs = 'YYYY-MM-DD hh:mm:ss'

        if (dataInicial && horaInicial && dataFinal && horaFinal) {

            const dataInicialFormatada = moment(dataInicial).format(dateFormatUs)
            const dataFinalFormatada = moment(dataFinal).format(dateFormatUs)

            const objDataInicial = moment(`${dataInicialFormatada}, ${horaInicial}`, dateTimeFormatUs)
            const objDataFinal = moment(`${dataFinalFormatada}, ${horaFinal}`, dateTimeFormatUs)

            if (isInicial) {

                if (objDataInicial.isAfter(objDataFinal)) {

                    return 'A data inicial não pode ser maior que a data final.'
                }
            } else {

                if (objDataFinal.isBefore(objDataInicial)) {

                    return 'A data final não pode ser menor que a data inicial.'
                }
            }
        }

        return true
    }
}